
















































import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { Category } from '@/types/categories';
import { MainMenuItem } from '@/types/mainMenuItems';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { Content } from '@/types/content';
import { getCarouselItems, updateCarouselItems } from '@/api/carouselItems';

const makeMenuItem = (category: Category): MainMenuItem => {
  let categoryMenu: MainMenuItem = {
    slug: category.meta!.slug,
    icon: category.icon,
    open_icon: category.icon,
    title: category.meta!.title,
  };

  if (category.children && category.children.length > 0) {
    categoryMenu.children = category.children.map(makeMenuItem);
  }

  return categoryMenu;
};

@Component
export default class CarouselManager extends Vue {
  @Prop() contentId!: string;

  @Action('categories/getCategories') getCategories!: Function;
  @Getter('categories/categories') categories!: Category[];
  @Action('content/getPage') getPage!: Function;
  @Getter('content/content') content!: Content[];

  active: string[] = [''];
  tree = [];

  isLoading: boolean = false;
  isSaving: boolean = false;

  selected: string[] = [];

  get contentItems() {
    return this.isLoading
      ? []
      : this.content.map(content => ({
          id: content.id,
          title: content.meta.title,
        }));
  }

  get menuItems() {
    return _.orderBy(this.categories, ['name'], ['asc']).map(makeMenuItem);
  }

  async onUpdate() {
    this.isSaving = true;
    await updateCarouselItems(this.contentId, this.selected);
    this.isSaving = false;
  }

  @Watch('active')
  async onTreeItemActive() {
    this.isLoading = true;
    await this.getPage({ page: 1, category: this.active[0] });
    this.isLoading = false;
  }

  async created() {
    this.getCategories();
    this.selected = await getCarouselItems(this.contentId);
  }
}
